export enum UploadFileTypes {
    avatar = 'avatar',
    file = 'file',
    image = 'image',
}

export enum FileTypes {
    pdf = 'pdf',
    docx = 'docx',
}

export enum TooltipPlacement {
    TOP = 'top',
    TOP_START = 'top-start',
    TOP_END = 'top-end',
    BOTTOM = 'bottom',
    BOTTOM_START = 'bottom-start',
    BOTTOM_END = 'bottom-end',
    LEFT = 'left',
    LEFT_START = 'left-start',
    LEFT_END = 'left-end',
    RIGHT = 'right',
    RIGHT_START = 'right-start',
    RIGHT_END = 'right-end',
}

export enum MailProviders {
    GMAIL = 'gmail',
    OUTLOOK = 'outlook',
}

export enum TrackableSourceNames {
    X = 'X',
    FACEBOOK = 'Facebook',
    LINKEDIN = 'Linkedin',
    TELEGRAM = 'Telegram',
    EMAIL = 'Email',
    DIRECT = 'Direct',
    WHATSAPP = 'WhatsApp',
    SITE = 'Site',
}
